import React from 'react';

import { Icon } from '@/components/memo';

import './DataItems.css';

interface DataItemProps {
  icon: string;
  title: string;
  value: string | number;
}

const DataItem: React.FC<DataItemProps> = React.memo(
  ({ icon, title, value }) => {
    return (
      <div className="data-item">
        <div className="data-item__label">
          <Icon icon={icon} className="data-item__icon" />
          <p className="data-item__title">{title}</p>
        </div>
        <p className="data-item__value">{value}</p>
      </div>
    );
  }
);

interface DataItemsProps {
  items: {
    icon: string;
    title: string;
    value: string | number;
  }[];
}

const DataItems: React.FC<DataItemsProps> = React.memo(({ items }) => {
  return (
    <div className="data-items">
      {items.map((item, index) => (
        <DataItem
          key={index}
          icon={item.icon}
          title={item.title}
          value={item.value}
        />
      ))}
    </div>
  );
});

export default DataItems;
